import React, { useState } from "react";
import PropTypes from "prop-types";
import { toastr } from "react-redux-toastr";
import { createIncomingQuote } from "MODULES/parts/actions/incomingQuotes";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import {
  INCOMING_LINE_ITEMS,
  NOT_AWAITING_REPLY
} from "MODULES/IncomingQuotes/constants";
import api from "APP_ROOT/api";
import { useCurrentUser, useDispatch } from "APP_ROOT/hooks";
import Form from "MODULES/parts/components/Detail/IncomingQuotes/Create/Form";

const {
  [NOT_AWAITING_REPLY]: _,
  ...quoteTypes
} = INCOMING_LINE_ITEMS.quoteType;

export default function Create({ open, close }) {
  const [selectedCompany, setSelectedCompany] = useState({});
  const { onSubmit } = useOnSubmit(close);
  const setSubmittedWith = () => {};

  const initialValues = {
    buyer_id: useCurrentUser().id,
    incoming_quote_line_item: {
      quote_type: "standard",
      cost: ""
    }
  };

  return (
    <Modal open={open} close={close}>
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Create a New Incoming Quote</h4>
      </Header>
      <Form
        close={close}
        initialValues={initialValues}
        onSubmit={onSubmit}
        setSubmittedWith={setSubmittedWith}
        quoteTypes={quoteTypes}
        selectedCompany={selectedCompany}
        setSelectedCompany={setSelectedCompany}
        modal
      />
    </Modal>
  );
}

Create.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
};

function useOnSubmit(close) {
  const dispatch = useDispatch();
  const afterCreate = (quote, sendQuote) => {
    if (sendQuote) {
      api.incomingQuotes.send(quote.id, quote).then(() => {
        toastr.success("Success", "RFQ successfully sent.");
      });
    }
    close();
  };
  const onSubmit = data => {
    dispatch(createIncomingQuote(data, afterCreate));
  };
  return { onSubmit };
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/IncomingQuoteLineItems/Create/Create.jsx